import { makeStyles } from '@material-ui/core';

// Keep this hook in a dependency-free leaf module. It is consumed from
// quotes-v2 / auto-rfq / componentsV2, all of which are reachable from
// pages/products/index.tsx - importing it from the page barrel creates a
// circular import and resolves to undefined at render time.
export const useProductStyles = makeStyles({
  filtersHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid #e0e0e0`,
    height: 55
  },
  filterConteiner: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  dialogPaper: {
    width: '95%',
    height: '95%',
    maxHeight: '95% !important',
    maxWidth: '95% !important',
    borderRadius: 24
  }
});
